function AmazonCtrl(toaster, $scope, $state, $stateParams,AppSettings, AmazonService, CommonService, $rootScope, UserService) {
  'ngInject';

  $rootScope.$on("UpdateAmazonJournalFromNotification", function(event, amazon_journal){
    vm.updateAmazonJournalFromNotification(amazon_journal);
  });

  const vm = this;
  vm.loading = false;
  vm.dataloading = false;
  vm.btndisabled = false;
  vm.amazonfileForm = {};
  vm.amazonCogs = [];
  vm.amazonForm = {};
  vm.responseReceived = false;
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.amazonForm.todate = !$stateParams.todate? '' : $stateParams.todate;
  vm.amazonForm.fromdate = !$stateParams.fromdate? '' : $stateParams.fromdate;
  vm.journalId = !$stateParams.journalId ? '' : $stateParams.journalId;
  vm.sortBy = !$stateParams.sortBy? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.dateRegex = AppSettings.dateRegex;
  vm.isPendingJobs = false;
  vm.tryNowDate = '';
  vm.editForm = {};

  vm.init = function () {
    vm.url = `/organizations/${$stateParams.orgId}/amazon_journals.json?page=${vm.pageNumber}&size=${vm.size}&by_journal_id=${vm.journalId}&by_from=${vm.amazonForm.fromdate}&by_to=${vm.amazonForm.todate}&sort=${vm.sortBy}`;
    vm.dataloading = true;
    if ($stateParams.orgId) {
      AmazonService.getamazonJournals($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
        vm.dataloading = false;
        if (response.status == 200) {
          vm.amazonResponse = response.data;
          vm.currentPage = !vm.amazonResponse.pagination ? 1 : vm.amazonResponse.pagination.current_page;
          vm.totalPages = !vm.amazonResponse.pagination ? 1 : vm.amazonResponse.pagination.total_pages;
          vm.amazonCogs = response.data.amazon_journals;
        }
      });
      vm.amazonPending();
    }
  };

  vm.amazonPending = function(){
    UserService.showAmazonPendingJob( $stateParams.orgId, function (response){
        vm.isPendingJobs = response && response.data && response.data.count > 0;
      });
  };

  vm.viewDetail = function(journalId) {
      $state.go('user.organization.dashboard.amazon.detail', {orgId: $stateParams.orgId, journalid : journalId}, {inherit: false});
  };
  vm.getJournal = function() {
    if($stateParams.journalid) {
        AmazonService.getJournal($stateParams.orgId, $stateParams.journalid, function(response){
          vm.journal = response.data;
      });
    }
    else {
      $state.go('user.organization.dashboard.amazon.amazon-cogs', {inherit: false});
    }
  };
vm.updateAmazonJournalFromNotification = function(amazon_journal){
    if(Array.isArray(amazon_journal))
    {
      vm.init();
    }
  };
  vm.search = function (jrId, fromdate, todate) {
    $state.go('user.organization.dashboard.amazon.amazon-cogs', {pageNumber: vm.pageNumber, size: vm.size, journalId: jrId, fromdate: fromdate, todate: todate})
};

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.organization.dashboard.amazon.amazon-cogs', {sortBy: param});
  };

  vm.paginate = function (param) {
    vm.url = vm.amazonResponse.links[param];
    if( vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.dashboard.amazon.amazon-cogs', {pageNumber: vm.pageNumber, size: vm.size});
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.amazonResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.organization.dashboard.amazon.amazon-cogs', {pageNumber: vm.pageNumber, size: vm.size});
  };

  vm.onPikadaySelect = function (pikaday) {
   vm.amazonfileForm.date = pikaday.toString('YYYY-MM-DD');
  };

  vm.onPikadayOpen=function(pikaday){
     vm.amazonfileForm.date.setMaxDate(new Date());
  };

  vm.onPickadayTo = function (pikaday) {
    vm.amazonForm.todate = pikaday.toString();
    vm.fromDatePicker.setMaxDate(new Date(vm.amazonForm.todate));
  };

  vm.onPickadayFrom = function(pikaday) {
    vm.amazonForm.fromdate = pikaday.toString();
    vm.toDatePicker.setMinDate(new Date(vm.amazonForm.fromdate));
  };

  vm.viewJournal = function (journal) {
    AmazonService.getJournal($stateParams.orgId, journal.id, function (response) {
      vm.journal = response.data;
      if (response.status == 200) {
        $state.go('user.organization.dashboard.amazon.journal', {journalId: journal.id}, {inherit: false});
      }
    });
  };

  vm.saveFile = function (amazonForm) {
    vm.loading = true;
    vm.btndisabled = true;
    vm.responseReceived = false;
    AmazonService.reportExists( $stateParams.orgId,vm.amazonfileForm.date,function(resp){
      if (resp.data && !resp.data.errors){
        if (resp.data.status == 'success'){
          swal({
            title: "Notice",
            text: "The journal of Amazon COGS for this month is already created.",
            icon: "warning",
            dangerMode: true,
          })
            .then(willDelete => {
            if (willDelete) {
              vm.loading = false;
              vm.btndisabled = false;
              vm.responseReceived = true;
              // vm.uploadAmazonFile(amazonForm);
            } else {
              vm.loading = false;
              vm.btndisabled = false;
              vm.responseReceived = true;
            }
          });
        } else {
          vm.uploadAmazonFile(amazonForm);
        }
      } else {
        vm.loading = false;
        vm.btndisabled = false;
        vm.responseReceived = true;
        toaster.pop('error', CommonService.throwError(resp));
      }
    });

    vm.uploadAmazonFile = function(amazonForm){
      AmazonService.saveFile(vm.amazonfileForm, $stateParams.orgId, function (response) {
        vm.loading = false;
        vm.btndisabled = false;
        vm.responseReceived = true;
        vm.amazonfileForm = {};
        amazonForm.$setPristine();
        amazonForm.$setUntouched();
        if (response.status >= 200 & response.status <300) {
          toaster.pop('info', 'File uploaded successfully');
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    };
  };

  vm.onTryNowDateSelect = function (pikaday) {
    vm.tryNowDate = pikaday.toString('YYYY-MM-DD');
  };

  vm.tryNow = function () {
    vm.tryLoading = true;
    AmazonService.tryNow($stateParams.orgId, vm.tryNowDate, function (response) {
      vm.tryLoading = false;
      if (response.data.status == 'success') {
        toaster.pop('info', response.data.data);
      } else {
        toaster.pop('error', response.data.data);
      }
    });
  };

  vm.onPikadayOpenTryNow = function (pikaday) {
    pikaday.setMaxDate(new Date());
  };

  vm.editJournal = function (cogs) {
    vm.editForm.edited_ending = cogs.edited_ending;
    vm.editForm.edited_total = cogs.edited_total;
    vm.editForm.note = cogs.note;
    vm.cogsId = cogs.id;
    $('#editModal').modal('show');
  };

  vm.saveJournal = function () {
    AmazonService.updateJournal($stateParams.orgId, vm.cogsId, { amazon_journal: vm.editForm }, function (response) {
      if (response.status >= 200 && response.status < 300) {
        vm.amazonCogs[vm.amazonCogs.map(function (a) { return a.id; }).indexOf(response.data.id)] = response.data;
        toaster.pop('info', 'Amazon COGS Journal updated.');
        vm.editForm = {};
      }
      else {
        toaster.pop('error', CommonService.throwError(response));
      }
      $('#editModal').modal('hide');
    });
  };

  vm.repostJournal = function (journalId) {
    AmazonService.repostJournal($stateParams.orgId, journalId, function (response) {
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', response.data.message);
      } else {
        toaster.pop('error', 'Could not repost to xero.');
      }
    });
  };
}

export default{
  name: 'AmazonCtrl',
  fn: AmazonCtrl
};
